import React, { Dispatch, useContext, useEffect } from "react";
import { toast } from "react-hot-toast";
import { AppDispatchContext, AppStateContext } from "../App";
import { iStoreAction } from "../redux/reducers";
import i18n from "../i18n";
import {
  EwToastContent,
  getEwToastOptions,
  getEwToastVisual,
} from "./ewToast";

let displayed: any[] = [];

export const ENQUEUE_SNACKBAR = "ENQUEUE_SNACKBAR";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";
export const REMOVE_SNACKBAR = "REMOVE_SNACKBAR";

export const enqueueSnackbar = (notification: any): any => {
  const key = notification.options?.key || new Date().getTime() + Math.random();
  return {
    type: ENQUEUE_SNACKBAR,
    notification: { ...notification, key },
  };
};

export const closeSnackbar = (key: any): any => ({
  type: CLOSE_SNACKBAR,
  dismissAll: !key,
  key,
});

export const removeSnackbar = (key: any): any => ({
  type: REMOVE_SNACKBAR,
  key,
});

const Notifier = () => {
  const { notifications } = useContext(AppStateContext);
  const dispatch: Dispatch<iStoreAction> = useContext(AppDispatchContext);

  const storeDisplayed = (id: any) => {
    displayed = [...displayed, id];
  };

  useEffect(() => {
    notifications?.forEach(({ key, message, options = {}, dismissed = false }) => {
      if (dismissed) {
        toast.dismiss(key);
        return;
      }

      if (displayed.includes(key)) return;

      const variant = options.variant === "error" ? "error" : "success";
      const type = variant === "error" ? "Error" : "Success";
      const { color, progressColor, icon } = getEwToastVisual(type);
      const headerText =
        variant === "error"
          ? i18n.t("notifications.errorTitle", { ns: "common" })
          : i18n.t("notifications.successTitle", { ns: "common" });

      toast(
        (t) => (
          <EwToastContent
            t={t}
            headerText={headerText}
            message={message}
            accentColor={color}
            progressColor={progressColor}
            icon={icon}
          />
        ),
        getEwToastOptions({
          id: key,
          duration: options.autoHideDuration || undefined,
          notifierVariant: variant,
          style:
            variant === "error"
              ? {
                  backgroundColor: "white",
                  color: "rgb(0 0 0 / 87%)",
                  fontSize: "15px",
                }
              : undefined,
        })
      );

      storeDisplayed(key);
    });
  }, [notifications, dispatch]);

  return null;
};

export default Notifier;
